import React from 'react';
import { Box } from '@mui/material';
import RelatedSectionShell, { TilesGrid } from './RelatedSectionShell';

// ⬅️ Use the exact tile used on the dashboard for Triggers
import TriggerTile from '../tiles/TriggerTile';

import TriggersTable from './tables/TriggersTable';

const findTriggersSection = (sections) =>
  (sections || []).find((s) =>
    s?.title && /triggers/i.test(String(s.title))
  ) || null;

const sectionTotalFrom = (sec) =>
  sec?.section_total_interviews ?? sec?.sectionTotal ?? 0;

export default function RelatedTriggers({ sections, customerStories = [], jobName }) {
  const triggersSec = React.useMemo(() => findTriggersSection(sections), [sections]);
  if (!triggersSec) return null;

  // Respect existing order (already ranked like the dashboard)
  const tiles = Array.isArray(triggersSec.tiles) ? triggersSec.tiles : [];
  const top3 = tiles.slice(0, 3);

  return (
    <RelatedSectionShell section={triggersSec}>
      {/* Top-3 tiles (same visuals as dashboard) */}
      <Box sx={{ mb: 2 }}>
        <TilesGrid
          tiles={top3}
          renderTile={(t) => (
            <TriggerTile {...t} sectionTotal={sectionTotalFrom(triggersSec)} />
          )}
        />
      </Box>

      {/* Full table (preserve tile order = same ranking) */}
      <TriggersTable rowsSource={tiles} customerStories={customerStories} jobName={jobName} />
    </RelatedSectionShell>
  );
}
